import { ref } from 'vue';
import NotificationApiClass, { PaginationListWithFilters } from 'SharedDir/backend/api/classes/NotificationApiClass';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { NNotification } from 'SharedDir/declarations/notification';
import { usePagination } from 'SharedDir/common/composables/usePagination';
import { useQueryString } from 'SharedDir/common/composables/useQueryString';

export function useNotificationList() {
  const list = ref<NNotification.NotificationList>([]);
  const listTotalCount = ref(0);

  const {
    paginationParams,
    sanitizeQueryPagination,
    setPaginationFromData,
    defaultPaginator,
  } = usePagination();

  const {
    getQueryParams,
    setQueryParams,
  } = useQueryString(sanitizeQueryPagination(), paginationParams.value);

  /**
   * Получить все уведомления
   */
  const getAllNotifications = async () => {
    const response = await makeRequest(async () =>
      NotificationApiClass.getList(paginationParams.value as PaginationListWithFilters));

    if (response) list.value = response.messages;
    listTotalCount.value = response.totalCount;
    await setQueryParams(paginationParams.value);
  };

  const onRequest = async () => {
    setPaginationFromData(paginationParams.value);

    await getAllNotifications();
  };

  const clearParameters = async () => {
    paginationParams.value = defaultPaginator();

    await getAllNotifications();
  };

  return {
    getAllNotifications,
    clearParameters,
    paginationParams,
    list,
    onRequest,
    refresh: () => getAllNotifications(),
    listTotalCount,
  };
}
